/* eslint-disable max-lines */
import React, { Component, Fragment, lazy } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import debounce from 'lodash.debounce';
import classNames from 'classnames';
import qs from 'querystring';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge/Badge';
import CircularProgress from '@material-ui/core/CircularProgress';
import Toolbar from '@material-ui/core/Toolbar';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ExitIcon from '@material-ui/icons/ExitToApp';
import HelpIcon from '@material-ui/icons/Help';
import FavoriteIcon from '@material-ui/icons/Favorite';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SchoolIcon from '@material-ui/icons/School';
import SettingsIcon from '@material-ui/icons/Settings';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import TimelineIcon from '@material-ui/icons/Timeline';

import ControlledFeatureService from 'services/ControlledFeatureService';
import CookieStorageService from 'services/CookieStorageService';
import { getActiveLanguageCode, translate } from 'services/i18nService';
import LocalStorageService from 'services/LocalStorageService';
import { default as messagingServiceFactory } from 'services/MessagingService/MessagingService';
import {
  INITIATE_SEND_TIP,
  INITIATE_PRIVATE_MESSAGE,
  SHOW_REGISTRATION_MODAL,
  SHOW_BUY_TOKENS_MODAL_TRIGGER,
  SET_GENDER_PREFERENCE,
} from 'services/MessagingService/EventNames';
import ModalService from 'services/ModalService';
import trackingService from 'services/UITrackingService';
import ThemeService from 'themes/ThemeService';
import UserService from 'services/UserService';
import MessengerStore from 'pages/Settings/Inbox-new/State/MessengerStore';
import PeekStore from 'stores/PeekStore';
import ProfileStore from 'stores/ProfileStore';
import UserFriendsFavoritesStore from 'stores/UserFriendsFavoritesStore';
import UserStore from 'stores/UserStore';
import { isSfw } from 'pages/Directory/DirectoryHelpers';
import { fetchGalleryProfileImage } from 'pages/Settings/Profile/Galleries/Api';
import { ENUM_PROFILE_GALLERY_TYPE } from 'pages/Settings/Profile/Galleries/config';
import Button from 'components/Button/Button';
import EmailExistsModal from 'components/EmailExistsModal/EmailExistsModal';
import GuestBillingModal from 'components/GuestBillingModal/GuestBillingModal';
import Hyperlink from 'components/Hyperlink/Hyperlink';
import NotificationsHeader from 'components/NotificationsHeader/NotificationsHeader';
import ProfileLinkSwitch from 'components/ProfileLinkSwitch/ProfileLinkSwitch';
import ACCESS_LEVEL_NUM from 'enum/accessLevelsNum';
import {
  ACCOUNT_MENU,
  BANNERS_CONST,
  COUPLE,
  GENDER_PREFERENCE_REGEX,
  LOCAL_DATES_PAGES,
  MOBILE_MENU,
  PARSED_CHECKING_FOR_CRAWLERS,
  PORN_GAMES_PAGES,
  QUICK_FILTERS_MENU,
  SFW_LOCAL_DATES_PAGES,
  SFW_PORN_GAMES_PAGES,
} from 'enum/helpers';
import { GENDER } from 'enum/profile';
import routeDefinitions from 'enum/routeDefinitions';
import { MINUTE_AS_MILLISECONDS, SECOND_AS_MILLISECONDS } from 'enum/timeFormat';
import allUserGroups from 'enum/userGroups';
import getResizedProfileImage from 'utils/getResizedProfileImage';
import {
  generateID,
  convertTokensToDollars,
  usernameOrImpersonate,
  getMasterDomain,
  isAvailableToMove,
} from 'utils/helpers';
import { isImpersonatedUser } from 'utils/impersonate';
import { getSettingsRoute } from 'utils/routeHelpers';
import {
  isStudioAdminCheck,
  isStudioOwnerCheck,
} from 'utils/studio';
import {
  actionCreators as appStateActions,
  selector as appSelector,
} from 'app/AppState';
import {
  actionCreators as paymentActionsObject,
  selector as paymentSelector,
} from 'features/Payment/State';
import { selector as paymentHistorySelector } from 'features/Payout/State';
import {
  actionCreators as directoryListActions,
  selector as directorySelector,
} from 'pages/Directory/State';
import {
  actionCreators as listActions,
  selector,
} from 'pages/Drawer/State';
import {
  actionCreators as conversationsActions,
  selector as conversationsSelector,
} from 'pages/Settings/Inbox/State';
import { RegistrationModalCaller } from 'pages/RegistrationModal/utils';

import {
  actionCreators as firebaseActions,
  selector as firebaseSelector,
} from '../../../firebase/firebaseAuth/State';
import defaultImage from '../../../../images/header/unknown.png';
import defaultImageUnknown from '../../../../images/header/default_Unknown.60x60.png';
import goldstar from '../../../../images/goldstar.gif';
import stdAdminProfilePicture from '../../../../images/header/std-admin.jpg';
import stdOwnerProfilePicture from '../../../../images/header/std-owner.jpg';
import tokenIcon from '../../../../images/icontokens.png';
import styles from '../Header.css';
import CookieConsent from '../components/CookieConsent';


const CampaignCTAButton = lazy(() => import('components/CampaignCTAButton/CampaignCTAButton'));
const QuickFiltersList = lazy(() => import('components/QuickFiltersList/QuickFiltersList'));
const PeekStream = lazy(() => import('components/PeekStream/PeekStream'));
const FundsBanner = lazy(() => import('../FundsBanner/FundsBanner'));
const GuestMenu = lazy(() => import('../GuestMenu/GuestMenu'));
const StudioMenu = lazy(() => import('../StudioMenu/StudioMenu'));
const UserMenu = lazy(() => import('../UserMenu/UserMenu'));

const SPINNER_SIZE = 16;
const minCounter = 20;
const debounceDelay = 150;

@withRouter
@connect(appSelector, (dispatch) => {
  return { appActions: bindActionCreators(appStateActions, dispatch) };
})
@connect(selector, (dispatch) => {
  return { actions: bindActionCreators(listActions, dispatch) };
})
@connect(directorySelector, (dispatch) => {
  return { directoryActions: bindActionCreators(directoryListActions, dispatch) };
})
@connect(conversationsSelector, (dispatch) => {
  return { conversationsActions: bindActionCreators(conversationsActions, dispatch) };
})
@connect(firebaseSelector, (dispatch) => {
  return { firebaseAuth: bindActionCreators(firebaseActions, dispatch) };
})
@connect(paymentSelector, (dispatch) => {
  return { paymentActions: bindActionCreators(paymentActionsObject, dispatch) };
})
@connect(paymentHistorySelector)
@observer
class Header extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    appActions: PropTypes.object.isRequired,
    balance: PropTypes.number.isRequired,
    balanceError: PropTypes.bool.isRequired,
    conversationsActions: PropTypes.object.isRequired,
    directoryActions: PropTypes.object.isRequired,
    earningsDetails: PropTypes.object.isRequired,
    firebaseAuth: PropTypes.object.isRequired,
    isBalanceReturned: PropTypes.bool.isRequired,
    isUpsellModalVisible: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    paymentActions: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    onBroadcastButtonClick: PropTypes.func.isRequired,
    onHeaderMainLoaded: PropTypes.func.isRequired,
    drawer: PropTypes.object,
    fingerprintData: PropTypes.object,
    friendRequests: PropTypes.object,
    genderPreference: PropTypes.string,
    hideGuestMenu: PropTypes.bool,
    history: PropTypes.object,
    initialFilters: PropTypes.object,
    isEmailExistsModalOpen: PropTypes.bool,
    isMobileViewActive: PropTypes.bool,
    match: PropTypes.object,
    path: PropTypes.string,
    pathname: PropTypes.object,
    setGuestBilllingModalProp: PropTypes.func,
    showGuestBillingModal: PropTypes.bool,
    showRegistrationModal: PropTypes.bool,
    unreadThreads: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  };

  static defaultProps = {
    accountStatus: undefined,
    drawer: undefined,
    fingerprintData: undefined,
    friendRequests: undefined,
    genderPreference: undefined,
    hideGuestMenu: false,
    history: undefined,
    initialFilters: undefined,
    isEmailExistsModalOpen: false,
    isMobileViewActive: false,
    match: undefined,
    path: undefined,
    pathname: undefined,
    setGuestBilllingModalProp: () => undefined,
    showGuestBillingModal: false,
    showRegistrationModal: false,
    unreadThreads: undefined,
  };

  constructor(...args) {
    super(...args);
    this.messagingService = messagingServiceFactory();
    this.messagingService.on(INITIATE_SEND_TIP, this.openPrivateTipModal);
    this.messagingService.on(INITIATE_PRIVATE_MESSAGE, this.openPrivateMessageModal);
    this.messagingService.on(SHOW_REGISTRATION_MODAL, this.openRegistrationModal);
    this.messagingService.on(SHOW_BUY_TOKENS_MODAL_TRIGGER, this.onOpenBuyTokensOverlay);
    this.messagingService.on(SET_GENDER_PREFERENCE, this.onSetGenderPreference);
    this.props.onHeaderMainLoaded();

    this.IDS = {
      prefix: 'll3F6oc2',
      element: 'mainHeader',
      upgradeToGold: 'upgradeToGold',
      navigation() {
        const element = 'navigation';

        return {
          menuIcon: `${element}-menu_icon`,
          menuIconMobile: `${element}-menu-icon-mobile`,
          myAccount: `${element}-my_account`,
          female: `${element}-female`,
          male: `${element}-male`,
          trans: `${element}-trans`,
          goLive: `${element}-go-live`,
          meetAndFuck: `${element}-meet-and-fuck`,
          pornGames: `${element}-porn-games`,
          createFreeAcc: `${element}-create-free-acc`,
          meetAndFuckDropdown: `${element}-meet-and-fuck-dropdown`,
          pornGamesDropdown: `${element}-porn-games-dropdown`,
          studioExploreDropdown: `${element}-studio-explore`,
          mailIcon: `${element}-mail-icon`,
          studioDashboard: `${element}-dashboard`,
          studioRoster: `${element}-roster`,
          studioInsights: `${element}-insights`,
          studioMore: `${element}-studio-more`,
        };
      },
      userMenuContent() {
        const element = 'userMenuContent';

        return {
          admin: `${element}-admin`,
          adminInNavigation: `${element}-adminInNavigation`,
          'below-deck': `${element}-below-deck`,
          dashboard: `${element}-dashboard`,
          earnings: `${element}-performerhub-cashout`,
          explore: `${element}-explore`,
          'fan-club': `${element}-fan-club`,
          fanclubs: `${element}-fanclubs`,
          faq: `${element}-faq`,
          gold: `${element}-gold`,
          help: `${element}-help`,
          insights: `${element}-insights`,
          logout: `${element}-logout`,
          month: `${element}-month`,
          'my-shop': `${element}-shop`,
          myAccount: `${element}-my_account`,
          myLibrary: `${element}-my-library`,
          myProfile: `${element}-my_profile`,
          notificationsIcon: `${element}-notifications-icon`,
          performerhub: `${element}-performerhub`,
          performerTraining: `${element}-performer_training`,
          privateDirectory: `${element}-privateDirectory`,
          quickFilters: `${element}-quick-filters`,
          radio: `${element}-cam4-radio`,
          roster: `${element}-roster`,
          'swag-store': `${element}-swag-store`,
          studioDashboard: `${element}-studio-dashboard`,
          studioGoHome: `${element}-go-home-studio`,
          tags: `${element}-tags`,
          token: `${element}-token`,
          'vr-porn': `${element}-vr-porn`,
        };
      },
    };
    this.buyTokensIDS = {
      element: 'buyTokensBanner',
      prefix: 'T6GGc17z',
    };
    this.buyTokensKey = { banner: 'banner.wrapper' };
    this.buyTokensMakeId = generateID(this.buyTokensIDS.prefix, this.buyTokensIDS.element);
    this.makeId = generateID(this.IDS.prefix, this.IDS.element);
    this.notificationRef = React.createRef();
    this.state = {
      genderPreference: '',
      isProfileImageExist: false,
      friendRequestsCounter: 20,
      loading: false,
      sfw: isSfw(this.props.user),
      openedBuyTokensModalFromUID: false,
      openedLoginModalFromUID: false,
      showGuestBillingModal: true,
    };

    this.headerHeight = 42;
  }

  setFriendRequestsCounter = debounce(() => {
    this.setState((state) => {
      return { friendRequestsCounter: state.friendRequestsCounter + minCounter };
    });
  }, debounceDelay);

  componentDidMount() {
    const {
      user,
      conversationsActions: { getUnreadThreads },
      firebaseAuth,
      directoryActions,
      userActions: { updateUserStatusToGold },
      appActions: { watchUserNotificationsUpdate, toggleEmailExistsModal, setShowRegistrationModal },
      location,
    } = this.props;
    const username = user.user.getIn(['user', 'username']);
    if (username) {
      this.fetchGalleryProfile(username);
    }
    const offsetFriendRequest = 0;

    if (location.pathname === '/' && location.search !== '') {
      const queryParams = qs.parse(location.search.substring(1));

      if (queryParams.showLogin !== undefined) {
        ModalService.showModal(
          ModalService.MODAL_KEYS.LOGIN_MODAL_V2,
          { handleOpenRegistrationModal: () => setShowRegistrationModal(true, RegistrationModalCaller.HEADER_MAIN) }
        );
      }
      if (queryParams.showRegister !== undefined) {
        setTimeout(() => {
          this.openRegistrationModal();
        }, SECOND_AS_MILLISECONDS);
      }
      if (queryParams.showUpgradeToGold !== undefined) {
        if (username) {
          this.handleUpgradeToGold();
        } else {
          delete queryParams.showUpgradeToGold;
          const newParamsString = qs.stringify(queryParams);
          window.history.replaceState({}, window.document.title, newParamsString ? `/?${newParamsString}` : '/');
        }
      }
    }

    if (username !== null) {
      this.shouldCallSafeForWorkImageModal();
    }

    if (CookieStorageService.get('cam4-GUEST')) {
      if (CookieStorageService.get('cam4-GUEST').split('|').includes('expiredRejoinLink')) {
        this.toggleRetrieveAccount(true);
      } else if (
        CookieStorageService.get('cam4-GUEST').split('|').includes('showGuestUpsellForm') &&
        user.accessLevel === ACCESS_LEVEL_NUM.GUEST_BILLING
      ) {
        this.toggleGuestBilllingModal(true);
      }
      CookieStorageService.remove('cam4-GUEST');
    }
    if (user.user.getIn(['user', 'paymentInfo', 'guestPromptEmailExists'])) {
      toggleEmailExistsModal(true);
    }
    if (username) {
      const delay = 1500;
      setTimeout(() => {
        const { fingerprintData } = this.props;
        const headers = {};
        if (fingerprintData) {
          headers['X-Cam4-VisitorId'] = fingerprintData.visitorId;
          headers['X-Cam4-RequestId'] = fingerprintData.requestId;
        }
        getUnreadThreads(headers);
        this.props.appActions.getBalanceInfo(username, user);
        directoryActions.getFriendshipRequests(this.state.friendRequestsCounter, offsetFriendRequest);
        const { firebaseShard, firebaseToken } = this.props.user;
        const cam4FirebaseHostForInbox = firebaseShard;
        const cam4FirebaseTokenForInbox = firebaseToken;
        const { watchConversationState } = this.props.conversationsActions;
        const { doFirebaseAuthForInbox } = firebaseAuth;
        doFirebaseAuthForInbox(cam4FirebaseHostForInbox, cam4FirebaseTokenForInbox).then(() => {
          watchConversationState(user);
          watchUserNotificationsUpdate(user, { updateUserStatusToGold });
          MessengerStore.watchConversationState(user);
        });

        if (user.accessLevel >= ACCESS_LEVEL_NUM.BASIC) {
          this.props.userActions.getConsentStatus(username);
        }
      }, delay);
    }
    if (username) {
      this.getFFCounter();
      this.friendsFavoritesCounterInterval = setInterval(this.getFFCounter, MINUTE_AS_MILLISECONDS);
    }
  }

  componentDidUpdate = (prevProps) => {
    const {
      user,
      userActions: { updateUserStatusToGold },
      conversationsActions: { getUnreadThreads, watchConversationState },
      directoryActions,
      userActions,
      appActions: { watchUserNotificationsUpdate },
      firebaseAuth,
      isUpsellModalVisible,
      showGuestBillingModal,
    } = this.props;
    const offsetFriendRequest = 0;
    const username = user.user.getIn(['user', 'username']);
    if (showGuestBillingModal && !isUpsellModalVisible) {
      this.toggleGuestBilllingModal(showGuestBillingModal);
    }
    if (username && username !== prevProps.user.username) {
      const { fingerprintData } = this.props;
      const headers = {};
      if (fingerprintData) {
        headers['X-Cam4-VisitorId'] = fingerprintData.visitorId;
        headers['X-Cam4-RequestId'] = fingerprintData.requestId;
      }
      this.shouldCallSafeForWorkImageModal();
      getUnreadThreads(headers);
      this.getFFCounter();
      this.fetchGalleryProfile(username);

      if (user.accessLevel >= ACCESS_LEVEL_NUM.BASIC) {
        userActions.getConsentStatus(username);
        directoryActions.getFriendshipRequests(this.state.friendRequestsCounter, offsetFriendRequest);
      }

      this.props.appActions.getBalanceInfo(username, user);

      const { firebaseShard, firebaseToken } = user;
      const cam4FirebaseHostForInbox = firebaseShard;
      const cam4FirebaseTokenForInbox = firebaseToken;
      const { doFirebaseAuthForInbox } = firebaseAuth;
      doFirebaseAuthForInbox(cam4FirebaseHostForInbox, cam4FirebaseTokenForInbox).then(() => {
        watchConversationState(user);
        watchUserNotificationsUpdate(user, { updateUserStatusToGold });
      });
    }
    const currentRoute = this.props.location.pathname;
    const galleriesRoute = routeDefinitions.get(routeDefinitions.galleries.root, { username: user.username });
    if (prevProps.location.pathname !== currentRoute && currentRoute === galleriesRoute) {
      this.shouldCallSafeForWorkImageModal();
    }

    if (prevProps.user.username !== this.props.user.username) {
      /* eslint-disable-next-line */
      this.setState({ sfw: isSfw(user) });
    }
    this.handle24hrCampaign();
  };

  componentWillUnmount() {
    this.messagingService.off(INITIATE_SEND_TIP, this.openPrivateTipModal);
    this.messagingService.off(INITIATE_PRIVATE_MESSAGE, this.openPrivateMessageModal);
    this.messagingService.off(SHOW_REGISTRATION_MODAL, this.openRegistrationModal);
    this.messagingService.off(SET_GENDER_PREFERENCE, this.onSetGenderPreference);
    this.messagingService.off(SHOW_BUY_TOKENS_MODAL_TRIGGER, this.onOpenBuyTokensOverlay);
    clearInterval(this.friendsFavoritesCounterInterval);
  }

  fetchGalleryProfile = (username) => {
    fetchGalleryProfileImage(username).then((response) => {
      const profileGallery = response?.find((item) => item.galleryType === ENUM_PROFILE_GALLERY_TYPE.PROFILE);
      if (profileGallery?.mainImage) {
        this.setState({ isProfileImageExist: true });
      }
    });
  };

  getFFCounter = () => {
    UserFriendsFavoritesStore.getOnlineFriendsFavoritesCounter();
  };

  shouldCallSafeForWorkImageModal = () => {
    const { user, history } = this.props;
    const maxAccessLevel = 50;
    const localStorageKey = 'cam4_sfwImageOverlay_duration';
    const mustUploadSfwImage = user.user.getIn(['user', 'mustUploadSfwImage']);
    const isAdmin = user.user.get(['user', 'accessLevel']) >= maxAccessLevel;
    const isStudioAccount = isStudioOwnerCheck(user) || isStudioAdminCheck(user);
    const checkIfModalIsCallable = mustUploadSfwImage && !isAdmin && !isStudioAccount;

    const storageExpiresDuration = LocalStorageService.get(localStorageKey);
    const today = new Date();
    const extraHours = 168;
    const expiresDuration = today.setHours(today.getHours() + extraHours);

    const showModal = () => {
      const galleriesRoute = routeDefinitions.get(routeDefinitions.galleries.root, { username: user.username });
      const currentRoute = this.props.location.pathname;
      if (galleriesRoute === currentRoute) {
        ModalService.showModal(ModalService.MODAL_KEYS.SFW_IMAGE_MODAL, {
          username: user.username,
          history,
        });
        LocalStorageService.set(localStorageKey, expiresDuration);
      }
    };

    if (!checkIfModalIsCallable) {
      return;
    }

    if (storageExpiresDuration === null) {
      showModal();
    } else {
      const now = Date.now();
      const localStorageTimestemp = Number(storageExpiresDuration);

      if (now > localStorageTimestemp) {
        showModal();
      }
    }
  };

  handle24hrCampaign = () => {
    const {
      user: { user },
      paymentActions: { showBuyTokensModal },
      appActions: { setShowRegistrationModal },
    } = this.props;
    const { openedBuyTokensModalFromUID, openedLoginModalFromUID } = this.state;
    const queryParams = qs.parse(location.search.substring(1));
    const urlWithOffer = Object.keys(queryParams).some((item) => item.includes('checkout_offer_uid'));

    if (urlWithOffer) {
      const key = Object.keys(queryParams).filter((item) => item.includes('checkout_offer_uid'))[0];
      const username = user.getIn(['user', 'username']);
      const campaigns = user.getIn(['user', 'activeCampaigns']);
      const mainCampaign = campaigns && campaigns.get(0);
      const offerUid =
        mainCampaign && mainCampaign.get('passThrough') && mainCampaign.get('passThrough').get('offerUid');
      const cookie24HrOfferShown = CookieStorageService.get('cam4-24H-Offer-Shown');

      if (!username) {
        // unlogged user won't get 24hr campaign, we just prompt him to log in
        if (!openedLoginModalFromUID && !cookie24HrOfferShown) {
          ModalService.showModal(
            ModalService.MODAL_KEYS.LOGIN_MODAL_V2,
            {
              handleOpenRegistrationModal: () => setShowRegistrationModal(
                true,
                RegistrationModalCaller.HEADER_MAIN_24_HOUR
              ),
            }
          );

          this.setState({ openedLoginModalFromUID: true });
        }
      } else if (queryParams[key] === offerUid && !openedBuyTokensModalFromUID && !cookie24HrOfferShown) {
        if (!isAvailableToMove(location)) {
          return;
        }

        showBuyTokensModal();
        this.setState({ openedBuyTokensModalFromUID: true });
        const cookieExpires = new Date();
        cookieExpires.setDate(new Date().getDay() + 1);
        CookieStorageService.set('cam4-24H-Offer-Shown', 'true', {
          path: '/',
          expires: cookieExpires,
        });
      }
    }
  };

  openPrivateTipModal = ({ performerUserName, performerImage }) => {
    const { user } = this.props;
    const modalProps = {
      receiver: performerUserName,
      performerImage,
      user,
    };
    ModalService.showModal(ModalService.MODAL_KEYS.PRIVATE_TIP_MODAL, modalProps);
  };

  openPrivateMessageModal = (data) => {
    const {
      user: { username, accessLevel },
      appActions,
      directoryActions,
    } = this.props;
    const isUserLoggedIn = Boolean(username);
    const isGuestBilling = accessLevel === ACCESS_LEVEL_NUM.GUEST_BILLING;
    if (isGuestBilling) {
      ModalService.showModal(ModalService.MODAL_KEYS.GUEST_BILLING_MODAL, {
        close: () => ModalService.hideModal(),
        show: true,
      });
    } else if (isUserLoggedIn) {
      ModalService.showModal(ModalService.MODAL_KEYS.PRIVATE_MESSAGE_MODAL, data);
    } else {
      appActions.setShowRegistrationModal(true, RegistrationModalCaller.HEADER_PRIVATE_MESSAGE);
      directoryActions.setIsAnyModalShown(true);
    }
  };

  toggleRetrieveAccount = (flag) => {
    const { userActions: { togglePasswordRecoveryModal } } = this.props;
    togglePasswordRecoveryModal(flag);
  };

  toggleMenu = () => {
    const { toggle } = this.props.actions;
    toggle(MOBILE_MENU);
  };

  translateOption = (value) => {
    switch (value) {
      case GENDER.MALE:
        return translate('directory.tab.male');
      case GENDER.FEMALE:
        return translate('directory.tab.female');
      case COUPLE:
        return translate('directory.tab.couple');
      case GENDER.SHEMALE:
        return translate('directory.tab.shemale');
      case GENDER.ALL:
        return translate('directory.tab.all');
      case 'tags':
        return translate('categories.categories.quicklinks.trending.tags');
      case 'fan-club':
        return null;
      case 'swag-store':
        return translate('menuoptions.swag.store');
      case 'radio':
        return translate('menuoptions.cam4.radio');
      case 'my-shop':
        return translate('directory.tab.shop');
      case 'vr-porn':
        return translate('menuoptions.menu.link.vr.shows');
      case 'token':
        return translate('tipping.tipping.tokens.ucfirst');
      case 'gold':
        return translate('gold.gold.gold.cam4');
      case 'month':
        return translate('menuoptions.menu.link.contest');
      case 'dashboard':
        return translate('cam4bucks.cam4bucks.267');
      case 'roster':
        return translate('homepage.v2.studio.roster');
      case 'insights':
        return translate('profile.marketplace.insights');
      case 'admin':
        return translate('mail.mail.admin');
      default:
        return value;
    }
  };

  openLoginModal = () => {
    const { appActions, directoryActions } = this.props;
    appActions.setShowLoginModal(true);
    appActions.setShowRegistrationModal(false);
    directoryActions.setIsAnyModalShown(false);
  };

  toggleGuestBilllingModal = (flag) => {
    const {
      paymentActions: { toggleUpsellModal },
      setGuestBilllingModalProp,
    } = this.props;
    toggleUpsellModal(flag);
    if (!flag) {
      setGuestBilllingModalProp(flag);
      this.setState({ showGuestBillingModal: false });
    } else {
      this.setState({ showGuestBillingModal: true });
    }
  };

  openRegistrationModal = () => {
    const { appActions, directoryActions } = this.props;
    appActions.setShowRegistrationModal(true, RegistrationModalCaller.PROFILE);
    directoryActions.setIsAnyModalShown(true);
  };

  closeNotifications = (event) => {
    if (!(this.notificationRef.current && this.notificationRef.current.contains(event.target))) {
      event.stopPropagation();
      this.setState({ openNotifications: false });
    }
  };

  handleSexPrefAds = (genderPreference, isPornGames) => {
    const { user } = this.props;
    let targetPages = undefined;
    if (isSfw(user)) {
      targetPages = isPornGames ? SFW_PORN_GAMES_PAGES : SFW_LOCAL_DATES_PAGES;
    } else {
      targetPages = isPornGames ? PORN_GAMES_PAGES : LOCAL_DATES_PAGES;
    }

    switch (genderPreference) {
      case GENDER.FEMALE:
        return targetPages.desktopStraight;
      case GENDER.MALE:
        return targetPages.desktopGay;
      case GENDER.SHEMALE:
      case GENDER.TRANSGENDER:
        return targetPages.desktopTrans;
      default:
        return targetPages.desktopStraight;
    }
  };

  redirectIfNecessary = () => {
    const { path } = this.props;
    const genderPrefPath = `/:genderPreference${GENDER_PREFERENCE_REGEX}/:filter*`;
    const {
      directory,
      profile,
      tags,
      tagsMale,
      tagsFemale,
      tagsTrans,
      tagsCouples,
      tagsAll,
      tagsGeneral,
      fanClub,
      token,
      gold,
      contest,
      weakPasswordReset,
    } = routeDefinitions;
    const pagesToNotRedirectFrom = [
      genderPrefPath,
      directory,
      profile,
      tags,
      tagsMale,
      tagsFemale,
      tagsTrans,
      tagsCouples,
      tagsAll,
      tagsGeneral,
      fanClub,
      token,
      gold,
      contest,
      weakPasswordReset,
    ];

    const shouldRedirect = !pagesToNotRedirectFrom.includes(path);

    if (shouldRedirect) {
      window.location = routeDefinitions.root;
    } else {
      window.location.reload();
    }
  };

  handleUpgradeToGold = () => {
    ModalService.showModal(ModalService.MODAL_KEYS.UPGRADE_TO_GOLD_MODAL);
  };

  showBrowserUpdateMessage = () => {
    // browser and version detection
    const showOldBrowserWarning = ControlledFeatureService.setUser(this.props.user).has('OLD_BROWSERS_WARNING');

    return showOldBrowserWarning && !PARSED_CHECKING_FOR_CRAWLERS;
  };

  closeGuestBillingModal = () => {
    this.toggleGuestBilllingModal(false);
  };

  openGuestBillingModal = () => {
    this.toggleGuestBilllingModal(true);
  };

  onSetGenderPreference = (preference) => {
    this.props.directoryActions.setGenderPreference(preference);
  };

  onOpenNotifications = () => {
    if (!isAvailableToMove(location)) {
      return;
    }

    this.setState((state) => {
      return { openNotifications: !state.openNotifications };
    });
  };

  onToggleAccountMenu = () => {
    const { toggle } = this.props.actions;
    toggle(ACCOUNT_MENU);
  };

  onOpenGuestBilllingModal = () => {
    this.toggleGuestBilllingModal(true);
  };

  onOpenQuickFiltersList = () => {
    if (!isAvailableToMove(location)) {
      return;
    }

    const { toggle } = this.props.actions;
    toggle(QUICK_FILTERS_MENU);

    trackingService.emit('toggleFriendsAndFavoritesMenu', { action: 'open' });
  };

  onOpenBuyTokensOverlay = () => {
    const { paymentActions, balanceError } = this.props;
    if (balanceError) {
      this.onBalanceRetry();

      return;
    }

    paymentActions.showBuyTokensModal();
  };

  onInboxButtonClick = (e) => {
    const { user } = this.props;
    if (isSfw(user)) {
      e.preventDefault();
    }
    this.closePopper(e);
  };

  onLogout = (event) => {
    event.preventDefault();

    if (UserStore.isLogoutResponsePending) {
      return;
    }

    if (CookieStorageService.get('isViewerBroadcast')) {
      CookieStorageService.remove('isViewerBroadcast', {
        domain: getMasterDomain(),
        path: '/',
      });
    }

    UserService
      .logout()
      .then(() => {
        this.redirectIfNecessary();
      });
  };

  onOpenUpgradeToGoldModal = () => {
    const { directoryActions } = this.props;

    ModalService.showModal(ModalService.MODAL_KEYS.UPGRADE_TO_GOLD_MODAL);
    directoryActions.setIsAnyModalShown(true);
  };

  onBalanceRetry = () => {
    const { user } = this.props;
    const username = user.user.getIn(['user', 'username']);
    this.props.appActions.getBalanceInfo(username, user);
  };

  renderBelowDeckOption = (value, className) => {
    const activeLanguageCode = getActiveLanguageCode();

    if (activeLanguageCode !== 'en') {
      return null;
    }

    return (
      <div className={className}>
        <Hyperlink
          key={value}
          className={styles.userMenuLink}
          href={routeDefinitions.beyondthedeck}
          id={this.makeId(this.IDS.userMenuContent()[value])}
          rel="noopener noreferrer"
          target="_blank"
          value={value}
        >
          {translate('homepage.below.deck')}
        </Hyperlink>
      </div>
    );
  };

  renderDropdownOptions = (values) => {
    const { user } = this.props;
    const userInfo = user.user.get('user');
    const isGold = userInfo.get('accessLevel') >= ACCESS_LEVEL_NUM.GOLD;
    const linkClasses = classNames({
      [styles.userMenuLink]: true,
      [styles.disabled]: isSfw(user),
    });

    const containerLinkClass = classNames({
      [styles.notAllowed]: isSfw(user),
    });

    return values.map((value) => {
      switch (value) {
        case 'month':
          return (
            <div className={containerLinkClass}>
              <Hyperlink
                key={value}
                className={linkClasses}
                href={`/contest/${value}`}
                id={this.makeId(this.IDS.userMenuContent()[value])}
                value={value}
              >
                {this.translateOption(value)}
              </Hyperlink>
            </div>
          );

        case 'dashboard':
        case 'roster':
          return (
            <Hyperlink
              key={value}
              href={`/studio/${value}`}
              id={this.makeId(this.IDS.userMenuContent()[value])}
              value={value}
            >
              {this.translateOption(value)}
            </Hyperlink>
          );

        case 'insights':
          return (
            <Hyperlink
              key={value}
              href={`/studio/${value}/earnings-report`}
              id={this.makeId(this.IDS.userMenuContent()[value])}
              value={value}
            >
              {this.translateOption(value)}
            </Hyperlink>
          );

        case 'gold':
          return (
            <Hyperlink
              key={value}
              href={routeDefinitions.gold}
              id={this.makeId(this.IDS.userMenuContent()[value])}
              value={value}
            >
              {isGold ? translate('menuoptions.menu.link.learn.about.gold') : this.translateOption(value)}
            </Hyperlink>
          );
        case 'tags':
          return (
            <div className={containerLinkClass}>
              <Hyperlink
                key={value}
                className={linkClasses}
                href={`/${value}`}
                id={this.makeId(this.IDS.userMenuContent()[value])}
                value={value}
              >
                {translate('categories.categories.quicklinks.trending.tags')}
              </Hyperlink>
            </div>
          );
        case 'below-deck':
          return this.renderBelowDeckOption(value, containerLinkClass);
        case 'swag-store':
          return (
            <Hyperlink
              key={value}
              className={styles.userMenuLink}
              href="https://www.camswag.store"
              id={this.makeId(this.IDS.userMenuContent()[value])}
              rel="noopener noreferrer"
              target="_blank"
              value={value}
            >
              {translate('menuoptions.swag.store')}
            </Hyperlink>
          );
        case 'radio':
          return (
            <Hyperlink
              key={value}
              className={styles.userMenuLink}
              href="https://cam4radio.com/"
              id={this.makeId(this.IDS.userMenuContent()[value])}
              rel="noopener noreferrer"
              target="_blank"
              value={value}
            >
              {translate('menuoptions.cam4.radio')}
            </Hyperlink>
          );
        default:
          return (
            <Hyperlink key={value} href={`/${value}`} id={this.makeId(this.IDS.userMenuContent()[value])} value={value}>
              {this.translateOption(value)}
            </Hyperlink>
          );
      }
    });
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      balance,
      user,
      userActions,
      paymentActions,
      history,
      appActions,
      showRegistrationModal,
      unreadThreads,
      drawer,
      friendRequests,
      directoryActions,
      earningsDetails,
      path,
      initialFilters,
      match,
      isUpsellModalVisible,
      appActions: { toggleEmailExistsModal },
      onBroadcastButtonClick,
      isEmailExistsModalOpen,
      isBalanceReturned,
      balanceError,
      location,
      isMobileViewActive,
      hideGuestMenu,
    } = this.props;
    const isLocationChangeUnavailable = !isAvailableToMove(location);

    const isStudioAdmin = isStudioAdminCheck(
      usernameOrImpersonate() ? usernameOrImpersonate(user.username, true) : user
    );
    const isStudioOwner = isStudioOwnerCheck(
      usernameOrImpersonate() ? usernameOrImpersonate(user.username, true) : user
    );

    const tokenBalanceClasses = classNames({
      [styles.tokenBalance]: true,
      [styles.adminTokenBalance]: isStudioAdmin || isStudioOwner,
    });

    const { showGuestBillingModal } = this.state;
    const { onlineFFCounter } = UserFriendsFavoritesStore;
    const { inTheatreMode } = ProfileStore;
    const { openedPeekWindows } = PeekStore;
    // had to do it like this since isTablet function from react-device-detect is not working properly
    const { offsetWidth } = document.body;
    const tSmall = 728;
    const tLarge = 1024;
    const maxAccessLevel = 50;
    const upgradeBtnText = (
      offsetWidth >= tSmall && offsetWidth <= tLarge ? 'gold.gold.transaction.page.Upgrade' : 'epay.upgrade.to.gold'
    );

    const friendsAndFavoritesCounter = onlineFFCounter > 0;
    const userInfo = this.props.user.user.get('user');
    const username = userInfo.get('username');
    const genderPreference = this.props.genderPreference ?? userInfo.get('genderPreference');
    const isAdmin = userInfo.get('accessLevel') >= maxAccessLevel;
    const isGold = userInfo.get('accessLevel') >= ACCESS_LEVEL_NUM.GOLD;
    const { isMinUserModerator } = UserStore;
    const historyPathname = history.location.pathname.split('/');
    const isStudioPage = historyPathname.length > 1 && historyPathname[1] === BANNERS_CONST.STUDIO;

    const explore = ['tags', 'token', 'gold', 'below-deck', 'swag-store', 'radio', 'month'];

    let shouldShowHeaderCTA = Boolean(ThemeService.theme.headerCTA);
    if (isStudioPage) {
      shouldShowHeaderCTA = false;
    }

    // STUDIO USER
    const settingsRouteStudio = getSettingsRoute(user);

    // REGULAR USER
    const adminRoute = routeDefinitions.get(routeDefinitions.account, { user: username });
    const settingsRouteUser = !isStudioAdmin && isImpersonatedUser() ? adminRoute : getSettingsRoute(user);

    const unreadMessagesCount = unreadThreads ? unreadThreads.length : 0;
    const calendarV2 = ControlledFeatureService.setUser(user).has(allUserGroups.CALENDAR_V2);
    let calendarUrl = undefined;
    if (calendarV2) {
      calendarUrl = routeDefinitions.get(routeDefinitions.calendar, { user: user.username });
    } else {
      calendarUrl = routeDefinitions.get(routeDefinitions.performerCalendar, { user: user.username });
    }

    // eslint-disable-next-line complexity
    const loggedInMenu = () => {
      const { isProfileImageExist } = this.state;
      let profilePicture = undefined;
      const isGuestBilling = userInfo.get('accessLevel') === ACCESS_LEVEL_NUM.GUEST_BILLING;
      if (isGuestBilling) {
        profilePicture = defaultImage;
      } else if (isStudioOwner) {
        profilePicture = stdOwnerProfilePicture;
      } else if (isStudioAdmin) {
        profilePicture = stdAdminProfilePicture;
      } else if (!isProfileImageExist) {
        profilePicture = defaultImageUnknown;
      } else {
        profilePicture = getResizedProfileImage(userInfo.get('profileImageUrl'));
      }

      const earningsAmount = convertTokensToDollars(+earningsDetails.get('balance'), true);
      const useInboxRewrite = ControlledFeatureService.setUser(user).has(allUserGroups.INBOX_REWRITE);
      const routeMail = useInboxRewrite ? routeDefinitions.newInbox : routeDefinitions.mail;
      const { userCashoutApproved } = UserStore;
      const maxCounter = 99;
      const badgeClasses = { badge: styles.badge };
      const inboxIconClass = {
        [styles.mailIcon]: true,
        [styles.sfwIcon]: isSfw(user),
      };
      const headerIconClasses = [
        styles.headerIcon,
        styles.notificationIconWrapper,
        { [styles.openedNotification]: this.state.openNotifications },
      ];

      return (
        <div className={classNames(styles.user, { [styles.userRunningOffer]: shouldShowHeaderCTA })}>
          {(!isStudioAdmin || (isStudioAdmin && !isStudioPage)) && !isMobileViewActive && (
            <Fragment>
              <FundsBanner
                balance={balance}
                balanceError={balanceError}
                history={history}
                isBalanceReturned={isBalanceReturned}
                setIsAnyModalShown={directoryActions.setIsAnyModalShown}
                user={user}
                onBalanceRetry={this.onBalanceRetry}
              />
              {shouldShowHeaderCTA && (
                <CampaignCTAButton />
              )}
            </Fragment>
          )}
          {isMobileViewActive && (
            <button
              className={tokenBalanceClasses}
              disabled={isLocationChangeUnavailable}
              id={this.buyTokensMakeId(this.buyTokensKey.banner)}
              onClick={this.onOpenBuyTokensOverlay}
            >
              <img alt="token icon" className={styles.tokensImg} src={tokenIcon} />
              {isBalanceReturned && !balanceError && (
                <span id="miniBalance">{balance}</span>
              )}
              {!isBalanceReturned && (
                <div className={styles.balanceProgressWrapper}>
                  <CircularProgress className={styles.balanceProgress} size={SPINNER_SIZE} />
                </div>
              )}
              {balanceError && <InfoIcon className={styles.warningIcon} />}
            </button>
          )}
          {!(isStudioOwner || isStudioAdmin || isGuestBilling) && (
            <div
              className={classNames(styles.headerIcon, styles.borderLeft)}
              id="toggleFriendsFavs"
              role="button"
              tabIndex={0}
              onClick={this.onOpenQuickFiltersList}
            >
              {friendsAndFavoritesCounter ? (
                <Badge
                  badgeContent={onlineFFCounter <= maxCounter ? onlineFFCounter : <span>{maxCounter}+</span>}
                  classes={badgeClasses}
                >
                  <FavoriteIcon className={styles.favoriteIcon} />
                </Badge>
              ) : (
                <FavoriteIcon className={styles.favoriteIcon} />
              )}
            </div>
          )}
          <QuickFiltersList
            drawer={drawer}
            history={history}
            path={path}
            sfw={isSfw(user)}
            toggle={this.props.actions.toggle}
            user={user}
          />

          {!isStudioPage && (
            <Hyperlink
              className={classNames(styles.headerIcon, 'hiddenSm', { [styles.sfwLink]: isSfw(user) })}
              href={routeMail}
              id="inboxButton"
              rel="noopener noreferrer"
              target="_self"
              onClick={this.onInboxButtonClick}
            >
              {unreadMessagesCount > 0 ? (
                <Badge badgeContent={unreadMessagesCount} classes={badgeClasses}>
                  <MailIcon className={inboxIconClass} />
                </Badge>
              ) : (
                <MailIcon className={inboxIconClass} />
              )}
            </Hyperlink>
          )}
          {!(isStudioOwner || isStudioAdmin || isGuestBilling) && (
            <div
              aria-pressed={this.state.openNotifications}
              className={classNames(headerIconClasses)}
              id="notificationContainerBell"
              role="button"
              tabIndex={0}
              onClick={this.onOpenNotifications}
            >
              {friendRequests.totalCount > 0 ? (
                <Badge badgeContent={friendRequests.totalCount} classes={badgeClasses}>
                  <NotificationsIcon
                    className={classNames({
                      [styles.openedNotificationIcon]: this.state.openNotifications,
                      [styles.notificationsIconActive]: !this.state.openNotifications,
                    })}
                  />
                </Badge>
              ) : (
                <NotificationsIcon
                  className={classNames({
                    [styles.openedNotificationIcon]: this.state.openNotifications,
                    [styles.notificationsIconInnactive]: !this.state.openNotifications,
                  })}
                  id={this.makeId(this.IDS.userMenuContent().notificationsIcon)}
                />
              )}
            </div>
          )}
          {this.state.openNotifications && (
            <div ref={this.notificationRef}>
              <NotificationsHeader
                closeNotifications={this.closeNotifications}
                friendRequests={friendRequests}
                friendRequestsCounter={this.state.friendRequestsCounter}
                getFriendshipRequests={directoryActions.getFriendshipRequests}
                setFriendRequestsCounter={this.setFriendRequestsCounter}
                sfw={isSfw(user)}
                updateFriendshipRequests={directoryActions.updateFriendshipRequests}
              />
            </div>
          )}

          {isGold && <img alt="gold" className={styles.goldstar} id="goldIcon" src={goldstar} />}

          {isGuestBilling && (
            <button
              className={styles.createAccount}
              disabled={isLocationChangeUnavailable}
              id={this.makeId(this.IDS.navigation().createFreeAcc)}
              onClick={this.onOpenGuestBilllingModal}
            >
              {translate('profile.profile.register.account')}
            </button>
          )}

          {(!isStudioAdmin || (isStudioAdmin && !isStudioPage)) && !isGold && !isGuestBilling && (
            <Button
              className={styles.upgradeToGold}
              colour="green"
              disabled={isLocationChangeUnavailable}
              id="upgradeGoldButton"
              label={translate(upgradeBtnText)}
              onClick={this.onOpenUpgradeToGoldModal}
            />
          )}

          <div className={styles.dropdown}>
            <button
              className="onlyMd"
              disabled={isLocationChangeUnavailable}
              id={this.makeId(this.IDS.navigation().menuIconMobile)}
              onClick={this.onToggleAccountMenu}
            >
              <img alt="avatar" className={styles.profilePicture} src={profilePicture} />
            </button>
            <button
              className={`hiddenMd ${styles.showMenuOptions}`}
              disabled={isLocationChangeUnavailable}
              id="toggleAccountButton"
            >
              <img alt={username} className={styles.profilePicture} src={profilePicture} />
            </button>

            <div className={`${styles.content} hiddenMd`} id="toggleMenuOptions">
              <div className={styles.group}>
                <div className={styles.userProfileName}>
                  <img alt={username} className={styles.profilePicture} src={profilePicture} />
                  {isGuestBilling && <p className={styles.username}>{translate('profile.profile.guest.user')}</p>}
                  {!isGuestBilling && <p className={styles.username}>{username}</p>}
                </div>
              </div>
              {!isGuestBilling && (
                <Fragment>
                  {(isStudioOwner || isStudioAdmin) && (
                    <div className={styles.group}>
                      <Hyperlink
                        href={routeDefinitions.studioDashboard}
                        id={this.makeId(this.IDS.userMenuContent().studioDashboard)}
                        target="_self"
                      >
                        <TimelineIcon className={styles.icons} />
                        {translate('homepage.header.studio.dashboard')}
                      </Hyperlink>
                    </div>
                  )}

                  <div className={!isStudioAdmin ? styles.group : ''}>
                    {!(isStudioOwner || isStudioAdmin) && (
                      <ProfileLinkSwitch
                        href={routeDefinitions.get(routeDefinitions.profile, { user: username })}
                        id={this.makeId(this.IDS.userMenuContent().myProfile)}
                      >
                        <AccountCircleIcon className={styles.icons} /> {translate('cam4support.cam4support.174')}
                      </ProfileLinkSwitch>
                    )}

                    {!isStudioAdmin && (
                      <ProfileLinkSwitch
                        href={isStudioOwner ? settingsRouteStudio : settingsRouteUser}
                        id={this.makeId(this.IDS.userMenuContent().myAccount)}
                      >
                        <SettingsIcon className={styles.icons} />{' '}
                        {translate(isStudioOwner ? 'homepage.v2.studio.settings' : 'cam4bucks.cam4bucks.869')}
                      </ProfileLinkSwitch>
                    )}

                    {!(isStudioOwner || isStudioAdmin) && (
                      <Hyperlink href={routeDefinitions.library} id={this.makeId(this.IDS.userMenuContent().myLibrary)}>
                        <SubscriptionsIcon className={styles.icons} /> {translate('profile.marketplace.library')}
                      </Hyperlink>
                    )}
                    {!(isStudioOwner || isStudioAdmin) && (
                      <Hyperlink
                        className={styles.links}
                        href={calendarUrl}
                        id={this.makeId(this.IDS.userMenuContent().calendar)}
                      >
                        <DateRangeIcon className={styles.icons} />
                        {translate('menuoptions.menu.link.calendar')}
                      </Hyperlink>
                    )}
                  </div>

                  <div className={styles.group}>
                    {!(isStudioOwner || isStudioAdmin) && userCashoutApproved && (
                      <ProfileLinkSwitch
                        href={routeDefinitions.get(routeDefinitions.performerHubMyAccount,
                          {
                            user: username,
                            view: 'cashout',
                          }
                        )}
                        id={this.makeId(this.IDS.userMenuContent().earnings)}
                      >
                        <AccountBalanceWalletIcon className={styles.icons} />{' '}
                        {translate('payment.payment.menuentry.earnings')} {earningsAmount}
                      </ProfileLinkSwitch>
                    )}

                    {!(isStudioOwner || isStudioAdmin) && (
                      <ProfileLinkSwitch
                        href={routeDefinitions.get(routeDefinitions.performerHubMyAccount,
                          {
                            user: username,
                            view: '',
                          }
                        )}
                        id="goToPerformerHub"
                      >
                        <AttachMoneyIcon className={styles.icons} /> {translate('profile.profile.performer.dashboard')}
                      </ProfileLinkSwitch>
                    )}

                    <Hyperlink
                      href={routeDefinitions.performerTraining}
                      id={this.makeId(this.IDS.userMenuContent().performerTraining)}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <SchoolIcon className={styles.icons} /> {translate('help.help.performer.training')}
                    </Hyperlink>
                  </div>
                </Fragment>
              )}

              <div className={styles.group}>
                <Hyperlink
                  href={routeDefinitions.faq}
                  id={this.makeId(this.IDS.userMenuContent().faq)}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <HelpIcon className={styles.icons} /> {translate('contacts.contacts.to.help')}
                </Hyperlink>

                <button
                  className={classNames({
                    [styles.disabled]: UserStore.isLogoutResponsePending,
                    [styles.logout]: true,
                  })}
                  disabled={
                    UserStore.isLogoutResponsePending ||
                    isLocationChangeUnavailable
                  }
                  id={this.makeId(this.IDS.userMenuContent().logout)}
                  onClick={this.onLogout}
                >
                  <ExitIcon className={styles.icons} /> {translate('menuoptions.menu.link.logout')}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const appBarClasses = { root: styles.header };
    const toolbarClasses = { root: styles.toolbar };

    return (
      <Fragment>
        {isUpsellModalVisible && (
          <GuestBillingModal
            close={this.closeGuestBillingModal}
            open={this.openGuestBillingModal}
            show={showGuestBillingModal}
          />
        )}
        {isEmailExistsModalOpen && (
          <EmailExistsModal
            appActions={appActions}
            close={toggleEmailExistsModal}
            paymentActions={paymentActions}
            userActions={userActions}
          />
        )}
        <AppBar classes={appBarClasses} id={this.IDS.element}>
          <Toolbar classes={toolbarClasses} disableGutters={true}>
            {isStudioAdmin || isStudioOwner ? (
              <StudioMenu
                genderPreference={genderPreference}
                history={history}
                isAdmin={isAdmin}
                isStudioAdmin={isStudioAdmin}
                isStudioOwner={isStudioOwner}
                renderDropdownOptions={this.renderDropdownOptions}
                settingsRouteStudio={settingsRouteStudio}
                toggleMenu={this.toggleMenu}
                translateOption={this.translateOption}
                user={user}
                userActions={userActions}
              />
            ) : (
              <UserMenu
                key={genderPreference}
                IDS={this.IDS}
                directoryActions={directoryActions}
                explore={explore}
                genderPreference={genderPreference}
                handleSexPrefAds={this.handleSexPrefAds}
                history={history}
                initialFilters={initialFilters}
                isAdmin={isAdmin}
                isGold={isGold}
                isMinUserModerator={isMinUserModerator}
                location={location}
                makeId={this.makeId}
                match={match}
                path={path}
                renderDropdownOptions={this.renderDropdownOptions}
                sfw={this.state.sfw}
                toggleMenu={this.toggleMenu}
                translateOption={this.translateOption}
                user={user}
                userActions={userActions}
                onBroadcastButtonClick={onBroadcastButtonClick}
              />
            )}
            {username ? loggedInMenu() : !hideGuestMenu && (
              <GuestMenu
                appActions={appActions}
                openRegistrationModal={this.openRegistrationModal}
                setIsAnyModalShown={directoryActions.setIsAnyModalShown}
                showRegistrationModal={showRegistrationModal}
              />
            )}
          </Toolbar>
          {this.showBrowserUpdateMessage() && (
            <div className={styles.outdatedBrowser}>
              <p>{translate('homepage.outdatedbrowser.description.new')}</p>
            </div>
          )}
        </AppBar>

        <CookieConsent />

        {!inTheatreMode &&
          openedPeekWindows.length > 0 &&
          openedPeekWindows.map((peek, index) => <PeekStream key={peek.performerName} index={index} info={peek} />)}
      </Fragment>
    );
  }

}

export default Header;
